import { lazy } from 'react';

import type { RoutesConfig, WrapRoutes } from '@virtuslab/nfs-shared/src/services/routes';

import { OfficeRoutes } from '../../../config/paths';

const OfficePage = lazy(async () => import('.'));

const config: RoutesConfig<WrapRoutes<typeof OfficeRoutes>> = {
  paths: {
    [OfficeRoutes.OFFICE]: {
      render: OfficePage,
    },
  },
};

export default config;
